/* BEBA: Subscribe & Save upgrade in the cart (drawer + cart page) and the clickable tiers on the cart-page insert.
   Turns every line that offers Subscribe & Save into a subscription on one schedule, changes the schedule,
   or switches the order back to one-time. Stord Shipment Protection follows the products' plan (same plan names),
   so protection renews with the subscription and goes back to one-time with it. */
(function(){
  if(window.__bebaUpgrade)return;window.__bebaUpgrade=true;
  const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  const isSp=h=>/^stord-(sp-pricing-|shipment-protection)/.test(h||'');
  const J={'Content-Type':'application/json',Accept:'application/json'};
  const norm=s=>(s||'').trim().toLowerCase();
  const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money=c=>(window.BEBA&&BEBA.money)?BEBA.money(c):'$'+(c/100).toFixed(2);
  const onCartPage=()=>/\/cart\/?$/.test(location.pathname);
  const cache={};
  const product=h=>cache[h]||(cache[h]=fetch(root+'products/'+h+'.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null));
  const getCart=()=>fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());

  function plansFor(p,variantId){
    const v=p&&p.variants.find(x=>x.id===variantId);if(!v||!v.selling_plan_allocations||!v.selling_plan_allocations.length)return [];
    const out=[];
    (p.selling_plan_groups||[]).forEach(g=>g.selling_plans.forEach(s=>{
      if(!v.selling_plan_allocations.some(a=>a.selling_plan_id===s.id))return;
      const adj=(s.price_adjustments||[])[0];
      out.push({id:s.id,name:s.name,pct:adj&&adj.value_type==='percentage'?adj.value:0});
    }));
    return out;
  }
  /* "Deliver every 2 weeks, 15% off" -> {every:"2 weeks", label:"Every 2 weeks · 15% off"} */
  function label(plan){const m=/every\s+([^,]+)/i.exec(plan.name);const every=m?m[1].trim():plan.name;return {every,label:'Every '+every+(plan.pct?' · '+plan.pct+'% off':'')}}

  async function analyze(cart){
    const lines=cart.items.filter(i=>!isSp(i.handle));
    const elig=[];let plans=[];
    for(const l of lines){const p=await product(l.handle);const ps=plansFor(p,l.variant_id);if(!ps.length)continue;elig.push({l,plans:ps});if(!plans.length)plans=ps}
    const names=new Set(elig.map(e=>e.l.selling_plan_allocation?norm(e.l.selling_plan_allocation.selling_plan.name):''));
    const allSub=elig.length>0&&elig.every(e=>e.l.selling_plan_allocation);
    const current=allSub&&names.size===1?plans.find(p=>norm(p.name)===[...names][0])||null:null;
    return {elig,plans,current,allSub};
  }

  /* Put every eligible line (and protection) on plan `name`, or back to one-time when name is null. */
  let busy=false;
  async function apply(name){
    if(busy)return;busy=true;
    const want=name?norm(name):null;
    try{
      for(let n=0;n<40;n++){
        const cart=await getCart();let changed=false;
        for(const l of cart.items){
          const cur=l.selling_plan_allocation?norm(l.selling_plan_allocation.selling_plan.name):null;
          if(cur===want)continue;
          const p=await product(l.handle);const ps=plansFor(p,l.variant_id);
          let target=null;
          if(want){const hit=ps.find(x=>norm(x.name)===want);if(!hit)continue;target=hit.id}
          else if(!cur)continue;
          const r=await fetch(root+'cart/change.js',{method:'POST',headers:J,body:JSON.stringify({id:l.key,quantity:l.quantity,selling_plan:target})});
          if(!r.ok)throw new Error('change failed');
          changed=true;break;
        }
        if(!changed)break;
      }
    }finally{busy=false}
    if(onCartPage()){location.reload();return}
    if(window.BEBA&&BEBA.refreshCart)await BEBA.refreshCart();
  }

  /* ---------- Upgrade card ---------- */
  const chk='<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  /* Same three choices as the product page: Monthly 10% off · Every 2 weeks 15% off · Weekly 20% off */
  const short2=p=>{const n=norm(p.name);if(/2\s*week/.test(n))return'Every 2 weeks';if(/week/.test(n))return'Weekly';if(/month/.test(n))return'Monthly';return label(p).every};
  function options(plans,sel,uid,attr){return `<div class="up__freq" role="radiogroup" aria-label="Delivery frequency" ${attr}>`+plans.map(p=>`<label class="up__opt"><input type="radio" name="${uid}" value="${esc(p.name)}"${sel&&p.name===sel.name?' checked':''}><span>${esc(short2(p))}${p.pct?`<small>${p.pct}% off</small>`:''}</span></label>`).join('')+'</div>'}
  const picked=g=>{const i=g&&g.querySelector('input:checked');return i?i.value:''};
  function savings(a,plan){return a.elig.reduce((s,e)=>s+(e.l.selling_plan_allocation?0:Math.round(e.l.final_line_price*(plan.pct||0)/100)),0)}
  function short(l){return esc(l.product_title.replace(/^BEBA YERBA\s*[—-]\s*/,'').replace(/\s*-\s*Functional.*$/i,'').replace(/ Flavor$/i,''))+(l.variant_title?' · '+esc(l.variant_title):'')}

  async function renderMount(m,cart){
    m.dataset.rendered='1';
    const a=await analyze(cart);
    if(!a.elig.length||!a.plans.length){m.hidden=true;m.innerHTML='';return}
    m.hidden=false;
    const max=Math.max(...a.plans.map(p=>p.pct||0));
    const uid='up'+Math.random().toString(36).slice(2,7);
    if(a.current){
      m.innerHTML=`<div class="up up--on"><p class="up__h"><span class="up__ok">${chk}</span>Subscribe &amp; Save is on</p>
        <p class="up__p">You save ${a.current.pct}% on this order and every delivery. Skip or cancel anytime.</p>
        <p class="up__k">Delivery frequency</p>${options(a.plans,a.current,uid,'data-up-change')}
        <button type="button" class="up__link" data-up-onetime>Switch to a one-time purchase</button>
        <p class="up__msg" role="status" aria-live="polite"></p></div>`;
    }else{
      const used=a.elig.find(e=>e.l.selling_plan_allocation);
      const sel=(used&&a.plans.find(p=>norm(p.name)===norm(used.l.selling_plan_allocation.selling_plan.name)))||a.plans[0];
      const items=a.elig.map(e=>`<li>${short(e.l)}</li>`).join('');
      m.innerHTML=`<div class="up"><p class="up__h">Make it a routine. Save up to ${max}% every time.</p>
        <p class="up__p">Upgrade ${a.elig.length>1?'these items':'it'} to Subscribe &amp; Save. Skip or cancel anytime.</p>
        <ul class="up__items">${items}</ul>
        <p class="up__k">Delivery frequency</p>${options(a.plans,sel,uid,'data-up-pick')}
        <button type="button" class="up__btn" data-up-go>Upgrade all to a subscription<span class="up__save" data-up-save></span></button>
        <p class="up__msg" role="status" aria-live="polite"></p></div>`;
      const s=m.querySelector('[data-up-save]'),pick=m.querySelector('[data-up-pick]');
      const upd=()=>{const p=a.plans.find(x=>x.name===picked(pick))||sel;const v=savings(a,p);s.textContent=v>0?' · save '+money(v):''};
      pick.addEventListener('change',upd);upd();
    }
  }

  async function run(m,fn,msg){
    const box=m.querySelector('.up');const out=m.querySelector('.up__msg');
    box&&box.classList.add('is-busy');m.querySelectorAll('button,select,input').forEach(x=>x.disabled=true);
    if(out)out.textContent=msg;
    try{await fn()}catch(e){if(out)out.textContent='Something went wrong. Please try again.';box&&box.classList.remove('is-busy');m.querySelectorAll('button,select,input').forEach(x=>x.disabled=false)}
  }
  document.addEventListener('click',e=>{
    const m=e.target.closest('[data-beba-upgrade]');if(!m)return;
    if(e.target.closest('[data-up-go]')){const v=picked(m.querySelector('[data-up-pick]'));if(v)run(m,()=>apply(v),'Upgrading your order…')}
    else if(e.target.closest('[data-up-onetime]'))run(m,()=>apply(null),'Switching to one-time…');
  });
  document.addEventListener('change',e=>{
    const g=e.target.closest('[data-up-change]');if(!g)return;const m=g.closest('[data-beba-upgrade]');const v=picked(g);if(v)run(m,()=>apply(v),'Updating your delivery frequency…');
  });

  /* ---------- Insert tiers (cart page): tap a tier to put the order on that schedule ---------- */
  async function renderTiers(box,cart){
    box.dataset.rendered='1';
    const a=await analyze(cart);
    const status=box.querySelector('[data-tier-status]');
    box.querySelectorAll('[data-tier]').forEach(b=>{
      const plan=a.plans.find(p=>String(p.pct)===b.dataset.tier);
      b.dataset.plan=plan?plan.name:'';
      const on=!!(a.current&&plan&&a.current.name===plan.name);
      b.setAttribute('aria-pressed',on?'true':'false');b.classList.toggle('is-on',on);
    });
    box.classList.toggle('has-plans',!!a.plans.length);
    if(!status)return;
    if(!a.elig.length)status.innerHTML='Pick your flavors, then choose Subscribe &amp; Save.';
    else if(a.current)status.innerHTML=`Your order is on Subscribe &amp; Save, every ${esc(label(a.current).every)}. <button type="button" class="ci__link" data-tier-onetime>Switch to one-time</button>`;
    else status.innerHTML='Tap a plan to switch this order to Subscribe &amp; Save. Skip or cancel anytime.';
  }
  document.addEventListener('click',e=>{
    const box=e.target.closest('[data-beba-tiers]');if(!box)return;
    const b=e.target.closest('[data-tier]'),one=e.target.closest('[data-tier-onetime]');
    const status=box.querySelector('[data-tier-status]');
    if(b){
      if(!b.dataset.plan){location.href=root+'#flavors';return}
      if(b.getAttribute('aria-pressed')==='true')return;
      box.classList.add('is-busy');if(status)status.textContent='Updating your order…';apply(b.dataset.plan).catch(()=>{box.classList.remove('is-busy');if(status)status.textContent='Something went wrong. Please try again.'});
    }else if(one){box.classList.add('is-busy');if(status)status.textContent='Switching to one-time…';apply(null).catch(()=>box.classList.remove('is-busy'))}
  });

  /* ---------- Wiring ---------- */
  function renderAll(cart,force){
    document.querySelectorAll('[data-beba-upgrade]').forEach(m=>{if(force||!m.dataset.rendered)renderMount(m,cart)});
    document.querySelectorAll('[data-beba-tiers]').forEach(b=>{if(force||!b.dataset.rendered)renderTiers(b,cart)});
  }
  document.addEventListener('beba:cart',e=>{if(e.detail&&!busy)renderAll(e.detail,true)});
  let t=null;
  function refreshMissing(){if(busy)return;const need=[...document.querySelectorAll('[data-beba-upgrade],[data-beba-tiers]')].some(x=>!x.dataset.rendered&&!x.closest('#drawer'));if(need)getCart().then(c=>renderAll(c,false)).catch(()=>{})}
  function init(){
    refreshMissing();
    /* The cart page re-renders its summary after quantity changes; re-fill any mount it replaced. */
    if('MutationObserver' in window&&document.querySelector('.cart-page,[data-beba-tiers]'))
      new MutationObserver(()=>{clearTimeout(t);t=setTimeout(refreshMissing,200)}).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
    /* Cart page quantity changes / removals (Horizon's cart event): refresh every card with the new cart. */
    document.addEventListener('cart:update',()=>{if(busy)return;clearTimeout(t);t=setTimeout(()=>getCart().then(c=>renderAll(c,true)).catch(()=>{}),250)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.BEBA=window.BEBA||{};BEBA.subscribeCart=apply;
})();
